import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import Layout from "../../../components/layout/Layout";
import FilterableTabCard from "../../../components/tabs/FilterableTabCard";
import CustomDrawer from "../../../components/layout/CustomDrawer";
import FilterPanel from "../../../components/filters/FilterPanel";
import { PublicationCalendar, Longnotes } from "./tabs";
import {
    useGetSectorPublicationsQuery,
    useGetAnalystListQuery,
} from "../../../redux/service/modules/dashboard";
import {
    useLazyGetLazyPublicationCalendarQuery,
    useLazyGetLazyLongNotesAnalysisQuery,
} from "../../../redux/service/modules/dashboard/lazzyQuery";
import CommonNavigator from "../../../components/common/CommonNavigator";
import { handleExport } from "../../../redux/service/modules/exportToExcel";
import { convertToDates } from "../../../utils/commonUtils";

const createTabs = () => [
    {
        id: "publication-calendar",
        label: "Publication Calendar",
        content: PublicationCalendar,
        showFilter: true,
        showDateRange: false,
    },
    {
        id: "long-notes",
        label: "Long Notes- Planned v/s Actual Publication",
        content: Longnotes,
        showFilter: true,
        showDateRange: false,
    },
];

const Publication = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [isFilterOpen, toggleFilter] = useState(false);
    const dateRange = useSelector((state) => state.date);
    const [requiredFilters, setRequiredFilters] = useState([]);
    const [filters, setFilters] = useState([]);

    const [filterDetails, setFilterDetails] = useState({
        appliedFilters: {
            initialDateRange: dateRange,
            analyst: [],
            sector: [],
        },
        filterCount: 0,
        rawFilters: {},
    });

    const { data: sectorData } = useGetSectorPublicationsQuery();
    const { data: analystList } = useGetAnalystListQuery();

    const [publicationExcelQuery] = useLazyGetLazyPublicationCalendarQuery();
    const [longNotesExcelQuery] = useLazyGetLazyLongNotesAnalysisQuery();
    const exportModule = {
        "publication-calendar": publicationExcelQuery,
        "long-notes": longNotesExcelQuery,
    };
    // Create available filters map
    const availableFiltersMap = {
        analyst: {
            name: "analystName",
            label: "Analyst Name",
            key: "analyst",
            options:
                analystList?.map((analyst) => ({
                    label: analyst.username,
                    id: analyst.id,
                })) || [],
            multiSelect: true,
        },
        sector: {
            name: "sectorName",
            label: "Sector",
            key: "sector",
            options:
                sectorData?.sectors?.map((sector) => ({
                    label: sector,
                    id: sector,
                })) || [],
            multiSelect: true,
        },
    };

    useEffect(() => {
        updateFiltersBasedOnRequired();
    }, [requiredFilters, sectorData, analystList]);

    const updateFiltersBasedOnRequired = () => {
        // Only show filters that are required by the current tab
        const activeFilters = requiredFilters
            .map((filterKey) => availableFiltersMap[filterKey])
            .filter(Boolean); // Remove any undefined filters

        setFilters(activeFilters);
    };

    const onFilterApply = (transformedFilters, filterCount, rawFilters) => {
        toggleFilter(false);
        setFilterDetails({
            appliedFilters: {
                ...transformedFilters,
                initialDateRange: dateRange,
            },
            filterCount,
            rawFilters,
        });
    };

    const tabs = createTabs();
    const currentTabId = searchParams.get("tab") || "publication-calendar";
    const [activeTab, setActiveTab] = useState(
        tabs.findIndex((tab) => tab.id === currentTabId)
    );

    const handleTabChange = (newValue) => {
        setActiveTab(newValue);
        setSearchParams({ tab: tabs[newValue].id });
        // Reset filters when changing tabs
        setFilterDetails({
            appliedFilters: {
                initialDateRange: dateRange,
                analyst: [],
                sector: [],
            },
            filterCount: 0,
            rawFilters: {},
        });
    };
    const triggerExportToExcel = () => {
        handleExport(exportModule[tabs[activeTab].id], {appliedFilters: filterDetails.appliedFilters, ...(dateRange) || {}})
    }
    return (
        <Layout>
            <div>
                <CommonNavigator
                    title={"Publications"}
                    showExportToExcel={true}
                    triggerExportToExcel={triggerExportToExcel}
                />
                <div className="mt-2">
                    <FilterableTabCard
                        tabs={tabs}
                        onTabClick={handleTabChange}
                        onFilterClick={() => toggleFilter(true)}
                        appliedFilters={filterDetails.appliedFilters}
                        filterCount={filterDetails.filterCount}
                        setRequiredFilters={setRequiredFilters}
                        value={activeTab}
                    />
                    <CustomDrawer open={isFilterOpen}>
                        <FilterPanel
                            key={`filter-panel-${activeTab}`}
                            filtersContent={filters}
                            handlePanelClose={() => toggleFilter(false)}
                            onApply={onFilterApply}
                            appliedFilters={filterDetails.rawFilters}
                        />
                    </CustomDrawer>
                </div>
            </div>
        </Layout>
    );
};

export default Publication;
